//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {getEmergencyContactInfo} from '../../../../api/newOwner';

export default {
    name: 'delivery-emergencyContactInfo',
    props: {
        recordId: {
            required: true,
            type: Number
        },
        roomId: {
            required: true,
            type: Number
        }
    },
    data() {
        return {
            emergencyContactInfo: {}
        };
    },
    methods: {
        getEmergencyContactInfo() {
            getEmergencyContactInfo(this.roomId).then(res => {
                if (res.data.result) {
                    this.emergencyContactInfo = {};
                    this.emergencyContactInfo = res.data.result;
                }

            });
        }
    },
    created() {
        this.getEmergencyContactInfo();
    }
};
